export default "__VITE_ASSET__ad0cdf78__"